var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './CenterModal.scss';
var CenterModal = function (_a) {
    var show = _a.show, handleClose = _a.handleClose, children = _a.children, customStyle = _a.customStyle, customContStyle = _a.customContStyle;
    var showHideClassName = show ? "center-modal display-block" : "center-modal display-none";
    return (_jsx("div", __assign({ style: customContStyle, className: showHideClassName, onClick: function (e) {
            e.stopPropagation();
            handleClose();
        } }, { children: _jsxs("section", __assign({ className: "center-modal-main", onClick: function (e) { return e.stopPropagation(); }, style: customStyle }, { children: [_jsx("button", __assign({ className: "close-button", onClick: handleClose }, { children: "\u00D7" })), children] })) })));
};
export default CenterModal;
